import { const_var, params } from "../../redux/reducers/reducer";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import { editValidation, wallNameArrForValid } from "../../utils/Validation";
import * as utils from "../../redux/reducers/utils";
import { AddDoorComponentonWall } from "../common/common.helper";
import { updateWainscotPriceFlag } from "../building/building_color/wainscotColor.helper";
import { updateWalkinWindowlegCutPrice } from "../lean_building_pricing/lean_building_wall/leanBuildingWall.helper";
export const changeComponentData = (state, action) => {
	updateWainscotPriceFlag();
	params.trimkit = params.chain_hoist = params.header_seal = params.certified_door = params.automatic_openers = params.insulated = params.motor = params.threshold = false;
	Object.keys(params).map((e) => {
		if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
			let prop = e.replace("entry_", "");
			params[prop] = false;
		}
	});
	var currentComp = JSON.parse(JSON.stringify(action.component_Obj));

	let doorName = `${action.component_Obj.child_array_key}_${action.doorName.replace(" ", "_").toLowerCase()}`;
	state.isotherDoorType = doorName;
	cuComponent.RemoveDoorComponent(
		currentComp.uniqueId,
		currentComp.entry_type,
		doorName,
		currentComp.component_wall_name,
		currentComp.name,
		currentComp.parent_array_key,
		currentComp.child_array_key,
		currentComp.nested_array_key,
		currentComp.entry_rotation,
		currentComp.entry_position,
		undefined,
		undefined,
		currentComp.component_name
	);

	return {
		...state,
		action
	};
};
export const chnageComponentSize = (state, action) => {
	updateWainscotPriceFlag();
	let updateComponent = action.doorsize + action.uniqueId + action.component_Obj + action.is_trim + action.is_Checked;
	let currentComponent = JSON.parse(JSON.stringify(action.component_Obj));
	let currentComponentName = currentComponent.name;
	if (action.doorsize === "Custom Size") {
		let customSizeObj =
			const_var.newComponentArray &&
			const_var.newComponentArray[currentComponent.parent_array_key] &&
			const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key] &&
			const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key] &&
			const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["CustomSize"] &&
			const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["CustomSize"].length > 0
				? const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["CustomSize"]
				: [];
		currentComponentName = "5x5";
		if (currentComponent.parent_array_key == "Walk" || currentComponent.parent_array_key == "Walk_Frameout") {
			if (customSizeObj && customSizeObj.length > 0) {
				currentComponentName = customSizeObj[0].width_range.split("-")[0] + "x" + customSizeObj[0].height_range.split("-")[0];
			} else {
				currentComponentName = "24x70";
			}
		} else if (currentComponent.parent_array_key == "Windows" || currentComponent.parent_array_key == "Windows_Frameout") {
			if (customSizeObj && customSizeObj.length > 0) {
				currentComponentName = customSizeObj[0].width_range.split("-")[0] + "x" + customSizeObj[0].height_range.split("-")[0];
			} else {
				currentComponentName = "24x24";

				if (currentComponent.nested_array_key.includes("Transom Window")) {
					currentComponentName = "24x10";
				}
			}
		} else {
			if (currentComponent.parent_array_key == "Garage_Frameout") {
				if (customSizeObj && customSizeObj.length > 0) {
					currentComponentName = customSizeObj[0].frame_out_length.split("-")[0] + "x" + customSizeObj[0].frame_out_height.split("-")[0];
				} else {
					currentComponentName = action.is_Checked == true ? "5x5" : const_var.customFrameoutInitialSize;
				}
			} else {
				if (customSizeObj && customSizeObj.length > 0) {
					currentComponentName = customSizeObj[0].width_range.split("-")[0] + "x" + customSizeObj[0].height_range.split("-")[0];
				} else {
					currentComponentName = "5x5";
				}
			}
		}
	}

	let componentdimension = action.is_trim == "trim" || action.doorsize === "Custom Size" ? currentComponentName.split("x") : action.doorsize.split("x");
	const Doorwidth = currentComponent.entry_type == "garage_door" || currentComponent.entry_type == "garage_door_frameout" ? parseInt(componentdimension[0]) : parseInt(componentdimension[0]) / 12;
	const Doorheight = currentComponent.entry_type == "garage_door" || currentComponent.entry_type == "garage_door_frameout" ? parseInt(componentdimension[1]) : parseInt(componentdimension[1]) / 12;
	const compName = currentComponent.component_name == "standard_trim_door" ? "standard_door" : currentComponent.component_name;
	const selectedComponent = const_var.newDoorsArray.find((s) => s.uniqueId === action.uniqueId);
	const positionX = selectedComponent.positionX;
	const positionY = selectedComponent.positionY;

	const targetWallNameArr = wallNameArrForValid.find((subArray) => subArray.includes(currentComponent.component_wall_name));
	const sideArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== currentComponent.uniqueId && targetWallNameArr.includes(item.userData.wallName));

	let parentkey = "";
	let childkey = "";
	let nestedkey = "";

	let tempDoorHeight = action.doorsize.split("x")[1];
	let tempFinalComponentPrice = const_var.entry_wall_location[currentComponent.component_wall_name].includes("end") ? 1 : 0;
	if (action.component_Obj != undefined && action.component_Obj?.entry_size?.end_clearance != undefined) {
		tempFinalComponentPrice = const_var.entry_wall_location[currentComponent.component_wall_name].includes("end") ? action.component_Obj?.entry_size?.end_clearance : 0;
	}

	let tempWallHeight = params.p_h;

	let tempSec = cuComponent.wallnameBySec[currentComponent.component_wall_name];

	switch (tempSec) {
		case "leftlean":
			tempWallHeight = params.lean_p_h;
			break;
		case "rightlean":
			tempWallHeight = params.leanR_p_h;
			break;
		case "frontlean":
			tempWallHeight = params.leanF_p_h;
			break;
		case "backlean":
			tempWallHeight = params.leanB_p_h;
			break;
	}

	if (tempDoorHeight > tempWallHeight - tempFinalComponentPrice && (action.component_Obj.parent_array_key == "Garage" || action.component_Obj.parent_array_key == "Garage_Frameout") && tempSec != "center") {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
		const_var.showComponentEditBox = false;
	} else {
		if (currentComponent) {
			parentkey = currentComponent.parent_array_key;
			childkey = currentComponent.child_array_key;
			nestedkey = currentComponent.nested_array_key;
		}

		const editValidationVariable = editValidation({
			compType: currentComponent.entry_type,
			compName,
			width: Doorwidth,
			height: Doorheight,
			wallName: currentComponent.component_wall_name,
			parentkey,
			childkey,
			nestedkey,
			positionX,
			positionY,
			sideArray
		});

		const isEdit = currentComponent.component_name == "standard_trim_door" && action.is_Checked && action.is_trim === "trim" ? true : editValidationVariable.isEdit;
		const isChangePos = editValidationVariable.isChangePos;
		const_var.changeComponentSize = true;

		if (isEdit) {
			let customSizeObj =
				const_var.newComponentArray &&
				const_var.newComponentArray[currentComponent.parent_array_key] &&
				const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key] &&
				const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key] &&
				const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["CustomSize"] &&
				const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["CustomSize"].length > 0
					? const_var.newComponentArray[currentComponent.parent_array_key][currentComponent.child_array_key][currentComponent.nested_array_key]["CustomSize"]
					: [];
			if (action.doorsize == "Custom Size") {
				let colorData = "";
				const doorIndex = const_var.newDoorsArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
				if (doorIndex !== -1) {
					state.const_var.newDoorsArray[doorIndex].isCustomSizeChange = action.isCustomSizeChange;
				}

				let comDimension = "5x5";
				if (currentComponent.parent_array_key == "Walk" || currentComponent.parent_array_key == "Walk_Frameout") {
					if (customSizeObj && customSizeObj.length > 0) {
						comDimension = customSizeObj[0].width_range.split("-")[0] + "x" + customSizeObj[0].height_range.split("-")[0];
					} else {
						comDimension = "24x70";
					}
				} else if (currentComponent.parent_array_key == "Windows" || currentComponent.parent_array_key == "Windows_Frameout") {
					if (customSizeObj && customSizeObj.length > 0) {
						comDimension = customSizeObj[0].width_range.split("-")[0] + "x" + customSizeObj[0].height_range.split("-")[0];
					} else {
						comDimension = "24x24";

						if (currentComponent.nested_array_key.includes("Transom Window")) {
							comDimension = "24x10";
						}
					}
				} else {
					if (currentComponent.parent_array_key == "Garage_Frameout") {
						if (customSizeObj && customSizeObj.length > 0) {
							comDimension = customSizeObj[0].frame_out_length.split("-")[0] + "x" + customSizeObj[0].frame_out_height.split("-")[0];
							if (currentComponent.entry_doorNewType == "Custom Size") {
								currentComponent.entry_doorNewType = undefined;
								comDimension = const_var.customFrameoutInitialSize;
							}
						} else {
							comDimension = action.is_Checked == true ? "5x5" : const_var.customFrameoutInitialSize;
							if (currentComponent.entry_doorNewType == "Custom Size") {
								currentComponent.entry_doorNewType = undefined;
								comDimension = const_var.customFrameoutInitialSize;
							}
						}
					} else {
						if (customSizeObj && customSizeObj.length > 0) {
							comDimension = customSizeObj[0].width_range.split("-")[0] + "x" + customSizeObj[0].height_range.split("-")[0];
							if (currentComponent.entry_doorNewType == "Custom Size") {
								currentComponent.entry_doorNewType = undefined;
								comDimension = const_var.customFrameoutInitialSize;
							}
						} else {
							comDimension = "5x5";
						}
					}
				}

				currentComponent.entry_automatic_openers = false;
				currentComponent.entry_certified = false;
				currentComponent.entry_chain_hoist = false;
				currentComponent.entry_header_seal = false;
				currentComponent.entry_is_automatic_openers = false;
				currentComponent.entry_is_certified = false;
				currentComponent.entry_is_chain_hoist = false;
				currentComponent.entry_is_header_seal = false;
				params.header_seal = false;
				params.chain_hoist = false;
				params.automatic_openers = false;
				params.certified_door = false;
				params.insulated = false;
				params.motor = false;
				params.threshold = false;
				Object.keys(params).map((e) => {
					if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
						let prop = e.replace("entry_", "");
						params[prop] = false;
					}
				});
				params.extra_notes = currentComponent.entry_note;
				cuComponent.RemoveDoorComponent(
					currentComponent.uniqueId,
					currentComponent.entry_type,
					currentComponent.component_name,
					currentComponent.component_wall_name,
					comDimension,
					currentComponent.parent_array_key,
					currentComponent.child_array_key,
					currentComponent.nested_array_key,
					currentComponent.entry_rotation,
					currentComponent.entry_position,
					undefined,
					undefined,
					undefined,
					isChangePos
				);
			} else {
				const componentSize = action.is_trim !== "trim" ? action.doorsize : currentComponent.name;

				let checkComponentSize = action.doorsize.split("x");
				let checkHeight = 1;
				if (params.m_s_n == 3 && action.component_Obj.entry_type.includes("frameout")) {
					if (checkComponentSize[0] >= 13) {
						checkHeight = 2;
					}
				}

				if ((params.m_s_n == 9 || params.m_s_n == 33 || params.m_s_n == 122) && action.component_Obj.entry_type.includes("frameout")) {
					if (checkComponentSize[0] >= 12) {
						checkHeight = 2;
					}
				}

				let wallHeight = params.p_h;

				let endSide = const_var.entry_wall_location[currentComponent.component_wall_name];

				let clearance;
				const component = const_var.newComponentArray[currentComponent.parent_array_key].find((item) => item.type == currentComponent.child_array_key && item.name == currentComponent.nested_array_key);
				if (component) {
					clearance = component.sizes.find((item) => item.width == Doorwidth && item.height == Doorheight);
				}

				let sec = cuComponent.wallnameBySec[currentComponent.component_wall_name];

				switch (sec) {
					case "leftlean":
						wallHeight = params.lean_p_h;
						break;
					case "rightlean":
						wallHeight = params.leanR_p_h;
						break;
					case "frontlean":
						wallHeight = params.leanF_p_h;
						break;
					case "backlean":
						wallHeight = params.leanB_p_h;
						break;
				}

				if (params.singleSlope && currentComponent.component_wall_name == "c_b_l_w") {
					wallHeight = params.p_h - (Number(params.p_r_p) / 12) * params.p_w;
				}
				if (endSide.includes("end")) {
					if (clearance && clearance.end_clearance) checkHeight = clearance.end_clearance;

					let clearanceFromRoof = true;

					if (params.m_s_n == 11) {
						if (currentComponent.component_wall_name == "c_b_f_w" || currentComponent.component_wall_name == "c_b_b_w" || currentComponent.component_wall_name == "c_b_f_s_w") {
							let doors = const_var.entry_points.filter((e) => {
								if (e.component_wall_name == currentComponent.component_wall_name && e.uniqueId != currentComponent.uniqueId && e.entry_dimension_height >= params.p_h) {
									return true;
								}
							});
							if (doors.length > 0 || checkComponentSize[1] > params.p_h) clearanceFromRoof = false;
						}
					}

					if (params.m_s_n == 153 || params.m_s_n == 97) {
						if (currentComponent.component_wall_name == "c_b_f_w" || currentComponent.component_wall_name == "c_b_b_w" || currentComponent.component_wall_name == "c_b_f_s_w") {
							let doors = const_var.entry_points.filter((e) => {
								if (e.component_wall_name == currentComponent.component_wall_name && e.uniqueId != currentComponent.uniqueId && e.entry_dimension_height >= params.p_h - 1) {
									return true;
								}
							});
							if (doors.length > 0 || checkComponentSize[1] > params.p_h - 1) clearanceFromRoof = false;
						}
					}

					if (clearanceFromRoof) {
						const regularRoofOffsetHeight = params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0;
						switch (sec) {
							case "center":
								wallHeight += (Number(params.p_r_p) / 12) * (params.singleSlope ? params.p_w : params.p_w / 2) + regularRoofOffsetHeight;
								if (params.singleSlope) {
									// add this condition to fix the single slope door more than building size
									if (currentComponent.component_wall_name == "c_b_r_w") {
										wallHeight = params.p_h;
									} else if (currentComponent.component_wall_name == "c_b_f_w" || currentComponent.component_wall_name == "c_b_f_s_w") {
										wallHeight = params.p_h - (Number(params.p_r_p) / 12) * (params.p_w / 2 - selectedComponent.positionX - currentComponent.entry_dimension_width / 2);
										if (const_var.hightCategory == "leg_height") wallHeight = params.p_h;
										if (const_var.hightCategory == "pitch_height") wallHeight = params.p_h - (Number(params.p_r_p) / 12) * params.p_w;
									} else if (currentComponent.component_wall_name == "c_b_b_w") {
										wallHeight = params.p_h - (Number(params.p_r_p) / 12) * (params.p_w / 2 + selectedComponent.positionX + currentComponent.entry_dimension_width / 2);
										if (const_var.hightCategory == "leg_height") wallHeight = params.p_h;
										if (const_var.hightCategory == "pitch_height") wallHeight = params.p_h - (Number(params.p_r_p) / 12) * params.p_w;
									} else if (currentComponent.component_wall_name == "c_b_l_s_r_w") {
										wallHeight = params.p_h - (Number(params.p_r_p) / 12) * (params.p_w - parseInt(params.cB_addStorage_left)) - 1;
									} else if (currentComponent.component_wall_name == "c_b_r_s_l_w") {
										wallHeight = params.p_h - (Number(params.p_r_p) / 12) * parseInt(params.cB_addStorage_right) - 1;
									} else {
										wallHeight = params.p_h - (Number(params.p_r_p) / 12) * params.p_w;
									}
								}
								break;
							case "leftlean":
								wallHeight += (Number(params.b_l_t_r_p) / 12) * params.lean_p_w + regularRoofOffsetHeight;
								break;
							case "rightlean":
								wallHeight += (Number(params.b_l_t_r_pR) / 12) * params.leanR_p_w + regularRoofOffsetHeight;
								break;
							case "frontlean":
								wallHeight += (Number(params.b_l_t_r_pF) / 12) * params.leanF_p_w + regularRoofOffsetHeight;
								break;
							case "backlean":
								wallHeight += (Number(params.b_l_t_r_pB) / 12) * params.leanB_p_w + regularRoofOffsetHeight;
								break;
						}
					}
				} else if (clearance && clearance.side_clearance) {
					checkHeight = clearance.side_clearance;
				}
				if (checkComponentSize[1] > wallHeight - checkHeight && (currentComponent.parent_array_key == "Garage" || currentComponent.parent_array_key == "Garage_Frameout")) {
					const_var.isShowAlert = true;
					const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
					const_var.showComponentEditBox = false;
				} else if (
					(currentComponent.parent_array_key == "Garage" || currentComponent.parent_array_key == "Garage_Frameout") &&
					cuComponent.wallnameBySec[currentComponent.component_wall_name] == "center" &&
					!(const_var.editAPIDataByResponse.data?.main_created_at < "2025-09-19") &&
					const_var.isManufacturerForLeantoClearance &&
					params.m_s_n == const_var.manufacturerForLeantoClearance &&
					((params.add_left_lean &&
						(currentComponent.component_wall_name == "c_b_l_w" || currentComponent.component_wall_name == "c_b_l_s_w") &&
						positionX + checkComponentSize[0] / 2 > params.lean_p_pos - params.lean_p_d / 2 &&
						positionX - checkComponentSize[0] / 2 < params.lean_p_pos + params.lean_p_d / 2 &&
						checkComponentSize[1] >= params.lean_p_h + (params.lean_p_w * Number(params.b_l_t_r_p)) / 12) ||
						(params.add_right_lean &&
							(currentComponent.component_wall_name == "c_b_r_w" || currentComponent.component_wall_name == "c_b_r_s_w") &&
							-positionX + checkComponentSize[0] / 2 > params.leanR_p_pos - params.leanR_p_d / 2 &&
							-positionX - checkComponentSize[0] / 2 < params.leanR_p_pos + params.leanR_p_d / 2 &&
							checkComponentSize[1] >= params.leanR_p_h + (params.leanR_p_w * Number(params.b_l_t_r_pR)) / 12) ||
						(params.add_front_lean &&
							currentComponent.component_wall_name == "c_b_f_w" &&
							positionX + checkComponentSize[0] / 2 > params.leanF_p_pos - params.leanF_p_d / 2 &&
							positionX - checkComponentSize[0] / 2 < params.leanF_p_pos + params.leanF_p_d / 2 &&
							checkComponentSize[1] >= params.leanF_p_h + (params.leanF_p_w * Number(params.b_l_t_r_pF)) / 12) ||
						(params.add_back_lean &&
							currentComponent.component_wall_name == "c_b_b_w" &&
							-positionX + checkComponentSize[0] / 2 > params.leanB_p_pos - params.leanB_p_d / 2 &&
							-positionX - checkComponentSize[0] / 2 < params.leanB_p_pos + params.leanB_p_d / 2 &&
							checkComponentSize[1] >= params.leanB_p_h + (params.leanB_p_w * Number(params.b_l_t_r_pB)) / 12))
				) {
					const_var.isShowAlert = true;
					const_var.alertUsedFor = "DoorHeightGreaterThanLentoHeight";
					const_var.showComponentEditBox = false;
				} else {
					if (clearance && clearance.is_chain_hoist != undefined) {
						if (currentComponent.entry_chain_hoist == true && clearance.is_chain_hoist == 1) {
							currentComponent.entry_chain_hoist = true;
						} else {
							currentComponent.entry_chain_hoist = clearance.is_chain_hoist == 2 ? true : false;
						}
					}
					params.header_seal = currentComponent.entry_header_seal;
					params.chain_hoist = currentComponent.entry_chain_hoist;
					params.automatic_openers = currentComponent.entry_automatic_openers;
					params.certified_door = currentComponent.entry_certified;
					params.insulated = currentComponent.entry_insulated;
					params.motor = currentComponent.entry_motor;
					params.extra_notes = currentComponent.entry_note;
					if (params.m_s_n == 9 && currentComponent.parent_array_key == "Walk") {
						params.threshold = currentComponent.threshold || false;
					}

					if (currentComponent.component_name.includes("overhead_door_door") && clearance && clearance.door_add_ons) {
						const wOPtion = clearance.door_add_ons.filter((e) => e.door == "window_option");
						const doorName = currentComponent.component_name.replace("overhead_door_door_", "");
						const door = wOPtion[0].category.find((item) => item.category.split(" ").join("_").toLowerCase() == doorName);

						if (!door) {
							cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.component_name);
							currentComponent.component_name = "overhead_door_door_" + wOPtion[0].category[0].category.split(" ").join("_").toLowerCase();
						}

						if (clearance != undefined && clearance.door_add_ons != undefined) {
							const addOnOption = clearance.door_add_ons.find((e) => e.door == "add_on_options");
							Object.keys(currentComponent).map((e) => {
								if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
									let prop = e.replace("entry_", "");
									params[prop] = currentComponent[e];
									let isAvble = addOnOption?.category.find((option) => prop.includes(option.category.split(" ").join("_").toLowerCase()));
									if (!isAvble) {
										params[prop] = false;
									}
								}
							});
						}
					}

					if (currentComponent.component_name.includes("panel_garage_door_door_no_glass") && clearance && clearance.door_add_ons) {
						const wOPtion = clearance.door_add_ons.filter((e) => e.door == "window_option");
						const doorName = currentComponent.component_name.replace("panel_garage_door_door_", "");
						const door = wOPtion[0].category.find((item) => item.category.split(" ").join("_").toLowerCase() == doorName);
						if (!door) {
							cuComponent.RemoveDoorComponent(currentComponent.uniqueId, currentComponent.component_name);
							currentComponent.component_name = "panel_garage_door_door_" + wOPtion[0].category[0].category.split(" ").join("_").toLowerCase();
						}

						if (clearance != undefined && clearance.door_add_ons != undefined) {
							const addOnOption = clearance.door_add_ons.find((e) => e.door == "add_on_options");
							Object.keys(currentComponent).map((e) => {
								if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
									let prop = e.replace("entry_", "");
									params[prop] = currentComponent[e];
									let isAvble = addOnOption?.category.find((option) => prop.includes(option.category.split(" ").join("_").toLowerCase()));
									if (!isAvble) {
										params[prop] = false;
									}
								}
							});
						}
					}

					if (action.is_trim == "trim") {
						if (!state.const_var.checkDoorIsadded) {
							state.const_var.checkDoorIsadded = true;
							if (params.chain_hoist == true || params.header_seal == true || params.certified_door == true) {
								params.chain_hoist = params.chain_hoist;
								params.header_seal = params.header_seal;
								params.certified_door = params.certified_door;
							} else {
								params.chain_hoist = params.header_seal = params.automatic_openers = params.certified_door = params.insulated = params.motor = params.threshold = false;
							}

							Object.keys(params).map((e) => {
								if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
									let prop = e.replace("entry_", "");
									params[prop] = false;
								}
							});
							params.trimkit = action.is_Checked == true ? true : false;
							const_var.garageDoorColor.map((value, key) => {
								if (currentComponent.garage_door_color == value.hex_value.replace("#", "0x")) {
									state.params.g_d_c_name = value.name;
									state.params.g_d_c_id = value.id;
									params.g_d_c = value.hex_value.replace("#", "0x");
									state.params.g_d_c_Obj = value;
								}
							});

							if (params.trimkit == true) {
								cuComponent.RemoveDoorComponent(
									currentComponent.uniqueId,
									currentComponent.entry_type,
									"standard_trim_door",
									currentComponent.component_wall_name,
									currentComponent.name,
									currentComponent.parent_array_key,
									currentComponent.child_array_key,
									currentComponent.nested_array_key,
									currentComponent.entry_rotation,
									currentComponent.entry_position,
									undefined,
									undefined,
									"standard_door",
									isChangePos
								);
							} else {
								cuComponent.RemoveDoorComponent(
									currentComponent.uniqueId,
									currentComponent.entry_type,
									"standard",
									currentComponent.component_wall_name,
									currentComponent.name,
									currentComponent.parent_array_key,
									currentComponent.child_array_key,
									currentComponent.nested_array_key,
									currentComponent.entry_rotation,
									currentComponent.entry_position,
									undefined,
									undefined,
									"standard_trim_door",
									isChangePos
								);
							}
						}
					} else {
						if (currentComponent.entry_trim_kit == true && params.trimkit == false) {
							params.trimkit = true;
						}
						cuComponent.RemoveDoorComponent(
							currentComponent.uniqueId,
							currentComponent.entry_type,
							currentComponent.component_name,
							currentComponent.component_wall_name,
							action.doorsize,
							currentComponent.parent_array_key,
							currentComponent.child_array_key,
							currentComponent.nested_array_key,
							currentComponent.entry_rotation,
							currentComponent.entry_position,
							undefined,
							undefined,
							undefined,
							isChangePos
						);
					}
				}
			}
		} else {
			const_var.isShowAlert = !const_var.isShowAlert;
			const_var.alertUsedFor = "noSpaceAvailableOnWall";
		}
	}

	const_var.changeComponentSize = false;

	return {
		...state,
		newColor: updateComponent,
		action
	};
};
export const handleAddDoorComponent = (state, action) => {
	params.trimkit = params.chain_hoist = params.header_seal = params.automatic_openers = params.certified_door = params.insulated = params.motor = params.threshold = false;
	Object.keys(params).map((e) => {
		if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
			let prop = e.replace("entry_", "");
			params[prop] = false;
		}
	});
	params.extra_notes = "";
	params.g_d_c = "0xffffff";

	let doorHeight = action.componentsize.split("x")[1];
	let doorWidth = action.componentsize.split("x")[0];
	let finalComponentPrice = const_var.entry_wall_location[action.wall].includes("side") ? 1 : 0;
	if (action.obj != undefined && action.obj.side_clearance != undefined) {
		finalComponentPrice = const_var.entry_wall_location[action.wall].includes("side") ? action.obj.side_clearance : 0;
	}
	if (params.m_s_n == 11 && action.obj != undefined) {
		finalComponentPrice = const_var.entry_wall_location[action.wall].includes("end") ? action.obj.end_clearance : finalComponentPrice;

		if (action.wall == "c_b_f_w" || action.wall == "c_b_b_w" || action.wall == "c_b_f_s_w" || action.wall == "c_b_b_s_w") {
			let doors = const_var.entry_points.filter((e) => {
				if (e.component_wall_name == action.wall && e.entry_dimension_height >= params.p_h) {
					return true;
				}
			});
			if (doors.length == 0) finalComponentPrice = 0;
		}
	}

	let wallHeight = params.p_h;

	let sec = cuComponent.wallnameBySec[action.wall];

	switch (sec) {
		case "leftlean":
			wallHeight = params.lean_p_h;
			break;
		case "rightlean":
			wallHeight = params.leanR_p_h;
			break;
		case "frontlean":
			wallHeight = params.leanF_p_h;
			break;
		case "backlean":
			wallHeight = params.leanB_p_h;
			break;
	}

	if (params.m_s_n === 3 && action.compType == "garage_door_frameout") {
		const isSide = const_var.entry_wall_location[action.wall].includes("side");
		if (isSide) {
			finalComponentPrice = Number(doorHeight) >= 13 ? 2 : 1;
		}
	}

	// ########## Handling heritage end clearance ##########
	if ((params.m_s_n == 153 || params.m_s_n == 97) && action.obj != undefined) {
		finalComponentPrice = const_var.entry_wall_location[action.wall].includes("end") ? action.obj.end_clearance : finalComponentPrice;
	}

	if (doorHeight > wallHeight - finalComponentPrice && (action.parentkey == "Garage" || action.parentkey == "Garage_Frameout")) {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
		const_var.showComponentEditBox = false;
	} else if (
		(action.parentkey == "Garage" || action.parentkey == "Garage_Frameout") &&
		cuComponent.wallnameBySec[action.wall] == "center" &&
		!(const_var.editAPIDataByResponse.data?.main_created_at < "2025-09-19") &&
		const_var.isManufacturerForLeantoClearance &&
		params.m_s_n == const_var.manufacturerForLeantoClearance &&
		((params.add_left_lean &&
			(action.wall == "c_b_l_w" || action.wall == "c_b_l_s_w") &&
			0 + doorWidth / 2 > params.lean_p_pos - params.lean_p_d / 2 &&
			0 - doorWidth / 2 < params.lean_p_pos + params.lean_p_d / 2 &&
			doorHeight >= params.lean_p_h + (params.lean_p_w * Number(params.b_l_t_r_p)) / 12) ||
			(params.add_right_lean &&
				(action.wall == "c_b_r_w" || action.wall == "c_b_r_s_w") &&
				-0 + doorWidth / 2 > params.leanR_p_pos - params.leanR_p_d / 2 &&
				-0 - doorWidth / 2 < params.leanR_p_pos + params.leanR_p_d / 2 &&
				doorHeight >= params.leanR_p_h + (params.leanR_p_w * Number(params.b_l_t_r_pR)) / 12) ||
			(params.add_front_lean &&
				action.wall == "c_b_f_w" &&
				0 + doorWidth / 2 > params.leanF_p_pos - params.leanF_p_d / 2 &&
				0 - doorWidth / 2 < params.leanF_p_pos + params.leanF_p_d / 2 &&
				doorHeight >= params.leanF_p_h + (params.leanF_p_w * Number(params.b_l_t_r_pF)) / 12) ||
			(params.add_back_lean &&
				action.wall == "c_b_b_w" &&
				-0 + doorWidth / 2 > params.leanB_p_pos - params.leanB_p_d / 2 &&
				-0 - doorWidth / 2 < params.leanB_p_pos + params.leanB_p_d / 2 &&
				doorHeight >= params.leanB_p_h + (params.leanB_p_w * Number(params.b_l_t_r_pB)) / 12))
	) {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "DoorHeightGreaterThanLentoHeight";
		const_var.showComponentEditBox = false;
	} else {
		const_var.checkDoorIsadded = true;
		let colorData = "";

		AddDoorComponentonWall(action.compType, action.compName, action.wall, action.componentsize, action.parentkey, action.childkey, action.nestedkey);
	}

	return {
		...state,
		newColor:
			action.obj +
			action.compType +
			action.compName +
			action.wall +
			action.componentsize +
			action.parentkey +
			action.childkey +
			action.nestedkey +
			state.const_var.entry_points.length +
			const_var.isShowAlert +
			const_var.showComponentEditBox,
		action
	};
};
export const handleCustomComponent = (state, action, addCustomComponent) => {
	const_var.editComponentDimension = "";
	params.extra_notes = "";
	params.g_d_c = params.g_d_c;
	if (action.con == "walls") {
		const_var.sideDistance1 = 0;
		state.params.wallPos = action.event;
		if (state.params.wallPos != "Select") {
			if (action.event == "Front") {
				state.params.centerstorage = false;
				state.const_var.doorWall = "Front";
			}
			if (action.event == "Left") {
				if (params.add_left_lean == true && state.const_var.llsh == false) {
					state.const_var.doorWall = "LeftL";
				}
			}
			if (action.event == "Right") {
				if (params.add_right_lean == true && state.const_var.rlsh == false) {
					state.const_var.doorWall = "RightR";
				}
			}
		}
	} else if (action.con != "walls") {
		// console.log("HERE ------- 333333333333");
		state.params.wallPos = const_var.doorWall;
		params.b_l_t_s = const_var.doorWall;
		let componentName = "";
		state.params.p_a_g_r_u_d = "Select";
		state.params.p_d_c = "Select";
		state.params.p_w_cc = "Select";
		state.params.p_a_g_r_u_d_c_s = "Select";
		state.params.p_a_g_r_u_d_c_s1 = "Select";
		state.params.f_r_m_o_t = state.params.f_r_m_o_t1 = "Select";
		params.trimkit = params.chain_hoist = params.header_seal = params.automatic_openers = params.certified_door = params.insulated = params.motor = params.threshold = false;
		Object.keys(state.params).map((e) => {
			if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
				let prop = e.replace("entry_", "");
				params[prop] = false;
			}
		});

		if (action.value == "sectionalGarage" && action.event != "Select") {
			state.params.p_a_g_r_u_d = action.event;
			const_var.editComponentDimension = action.event;
			state.params.doorType = action.value;
			componentName = "garageRollUpDoor_" + action.event;
		}
		if (action.value == "Garage" && action.event != "Select") {
			state.params.p_a_g_r_u_d = action.event;
			const_var.editComponentDimension = action.event;
			state.params.doorType = action.value;
			componentName = "garageRollUpDoor_" + action.event;
		}
		if ((action.value == "Walk" || action.value == "WalkFrameout") && action.event != "Select") {
			state.params.p_d_c = action.event;
			const_var.editComponentDimension = action.event;
			state.params.doorType = action.value;
			componentName = "walkDoorSolid" + action.event;
		}
		if ((action.value == "Windows" || action.value == "WindowsFrameout") && action.event != "Select") {
			state.params.p_w_cc = action.event;
			const_var.editComponentDimension = action.event;
			state.params.doorType = action.value;
			componentName = "window" + action.event;
		}
		addCustomComponent(state, action.event, action.value, componentName);
		if (action.value == "CustomFrameout" && action.event != "Select") {
			const_var.editComponentDimension = action.event;

			const_var.custDM.w = action.event.split("X")[0];

			const_var.custDM.h = action.event.split("X")[1];

			state.params.f_r_m_o_t = const_var.custDM.w;
			state.params.f_r_m_o_t1 = const_var.custDM.h;
			state.params.p_a_g_r_u_d = state.params.f_r_m_o_t + "X" + state.params.f_r_m_o_t1 + "_Frameout";
			componentName = "garageRollUpDoor_" + state.params.f_r_m_o_t + "X" + state.params.f_r_m_o_t1 + "_Frameout";
			addCustomComponent(state, action.event, action.value, componentName);
		}
	}
	return {
		...state,
		newColor: action.event + state.params.wallPos + action.value
	};
};
export const updateDoorWindowsArray = (state, action) => {
	state.const_var.newDoorsArray = action.newArray;
	let newDataArra = [];
	const_var.UpdatedPriceData.surcharge_taxable = undefined;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	if (const_var.newDoorsArray) {
		const_var.newDoorsArray.map((item, index) => {
			let findIndex = const_var.entry_points.findIndex((data) => data.uniqueId == item.uniqueId);
			if (findIndex !== -1) {
				const_var.entry_points[findIndex].cutLegCount = item.cutLegCount;
				if (
					const_var.entry_points[findIndex].entry_type != undefined &&
					(const_var.entry_points[findIndex].entry_type == "walkin" || const_var.entry_points[findIndex].entry_type == "window" || const_var.entry_points[findIndex].entry_type == "walk_in_door")
				) {
					updateWalkinWindowlegCutPrice(const_var.entry_points[findIndex].uniqueId);
				}
				const_var.entry_points[findIndex].component_wall_name = item.userData.wallName;
				const_var.entry_points[findIndex].entry_location = const_var.entry_wall_location[item.userData.wallName];
				const_var.entry_points[findIndex].entry_position.positionX = item.positionX;
				newDataArra.push(const_var.entry_points[findIndex]);
			}
		});
	}
	if (newDataArra.length == const_var.newDoorsArray.length) {
		const_var.oldEntry_points = const_var.entry_points;
		const_var.entry_points = newDataArra;
	} else if (const_var.newDoorsArray.length > const_var.entry_points.length && const_var.oldEntry_points) {
		const restEntry_points = const_var.oldEntry_points.filter((item) => !const_var.entry_points.some((element) => element.uniqueId === item.uniqueId));
		const_var.entry_points = const_var.entry_points.concat(restEntry_points);
	} else {
		const_var.oldEntry_points = const_var.entry_points;
	}

	if (action.isChk != undefined && action.isChk && const_var.onDragUtilityPriceUpdateCenterBuilding != true) {
		cuBuilding.cP();
		if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right) {
			const_var.UpdatedPriceData.utility_price_changed = true;
		}
		if (params.cB_addStorage_check_front) {
			const_var.UpdatedPriceData.front_utility_price_changed = true;
		}
	}
	const_var.checkDoorIsadded = false;

	return {
		...state,
		newColor: JSON.stringify(state.const_var.newDoorsArray),
		action
	};
};
export const headerSealChainHoistAction = (state, action) => {
	let door = const_var.newDoorsArray.find((door) => door.uniqueId === Number(action.UniqueId));
	let returnData = "";
	if (door) {
		if (action?.bool_var?.is_header_seal == 1 && params.m_s_n == 87) {
			state.params.header_seal = true;
			door.DoorObj.header_seal = true;
		}
		if (action.value == "threshold" && params.m_s_n == 9) {
			state.params.threshold = !state.params.threshold;
			door.DoorObj.threshold = state.params.threshold;
		}
		if (action.value == "insulated") {
			state.params.insulated = !state.params.insulated;
			door.DoorObj.insulated = state.params.insulated;
		}

		if (action.value == "headerSeal") {
			state.params.header_seal = !state.params.header_seal;
			door.DoorObj.header_seal = state.params.header_seal;

			if ((state.params.m_s_n == 3 || state.params.m_s_n == 9) && state.params.header_seal == true) {
				state.params.automatic_openers = false;
				door.DoorObj.automatic_openers = state.params.automatic_openers;
			}
		}

		if (action.value == "chainHoist") {
			state.params.chain_hoist = !state.params.chain_hoist;
			door.DoorObj.chain_hoist = state.params.chain_hoist;
		}
		if (action.value == "certified_door") {
			state.params.certified_door = !state.params.certified_door;
			action.bool_var = state.params.certified_door;
			door.DoorObj.certified_door = state.params.certified_door;
		}
		if (action.value == "automatic_openers") {
			state.params.automatic_openers = !state.params.automatic_openers;
			door.DoorObj.automatic_openers = state.params.automatic_openers;

			if ((state.params.m_s_n == 3 || state.params.m_s_n == 9) && state.params.automatic_openers == true) {
				state.params.header_seal = false;
				door.DoorObj.header_seal = state.params.header_seal;
			}
		}
		if (action.value == "installation_is_end_wall") {
			door.DoorObj.installation_is_end_wall = door.DoorObj.installation_is_end_wall == "yes" ? "no" : "yes";
		}
		if (action.value == "installation_is_side_wall") {
			door.DoorObj.installation_is_side_wall = door.DoorObj.installation_is_side_wall == "yes" ? "no" : "yes";
		}
		if (action.value == "door_color_price") {
			state.params.g_d_c = action.event.hex_value.replace("#", "0x");
			state.params.g_d_c_name = action.event.name;
			state.params.g_d_c_id = action.event.id;
			state.params.g_d_c_Obj = action.event;
		}
		if (action.value == "extra_notes") {
			state.params.extra_notes = action.event;
			door.DoorObj.entry_note = state.params.extra_notes;
		}
	}
	if (
		const_var.c_f_a_per[params.p_e_i] &&
		const_var.c_f_a_per[params.p_e_i] != 0 &&
		const_var.c_f_aCer[params.p_e_i] != undefined &&
		const_var.c_f_aCer[params.p_e_i].percentage_of != undefined &&
		const_var.c_f_aCer[params.p_e_i].percentage_of &&
		const_var.c_f_aCer[params.p_e_i].percentage_of_cost > 0
	) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	let holdIndex = 0;
	var ii = const_var.entry_points.length;
	while (ii--) {
		if (const_var.entry_points[ii].uniqueId == action.UniqueId) {
			const doorDefualtValues = const_var.entry_points[ii].entry_size;
			if (const_var.entry_points[ii].parent_array_key == "Garage" && doorDefualtValues) {
				if (doorDefualtValues.is_header_seal && doorDefualtValues.is_header_seal == 2) state.params.header_seal = true;
				if (doorDefualtValues.is_chain_hoist && doorDefualtValues.is_chain_hoist == 2) state.params.chain_hoist = true;
				if (doorDefualtValues.is_certified && doorDefualtValues.is_certified == 2) state.params.certified_door = true;
				if (doorDefualtValues.is_automatic_openers && doorDefualtValues.is_automatic_openers == 2) state.params.automatic_openers = true;
				if (doorDefualtValues.is_header_seal && params.m_s_n == 87) {
					state.params.is_header_seal = true;
					door.DoorObj.header_seal = true;
				}
			}

			if (action.value == "headerSeal") const_var.entry_points[ii].entry_header_seal_price = doorDefualtValues.header_seal;
			if (action.value == "chainHoist") const_var.entry_points[ii].entry_chain_hoist_price = doorDefualtValues.chain_hoist;
			if (action.value == "automatic_openers") const_var.entry_points[ii].entry_automatic_openers_price = doorDefualtValues.automatic_openers;
			if (action.value == "installation_is_end_wall") const_var.entry_points[ii].installation_end_wall_fee = doorDefualtValues.installation_end_wall_fee;
			if (action.value == "installation_is_side_wall") const_var.entry_points[ii].installation_side_wall_fee = doorDefualtValues.installation_side_wall_fee;
			if (params.m_s_n == 9 && const_var.entry_points[ii].parent_array_key == "Walk" && action.value == "threshold") {
				const_var.entry_points[ii].threshold_price = const_var.checkmoreCustomizeFlag ? 0 : 30;
			}

			holdIndex = ii;
			const_var.entry_points[ii].entry_header_seal = const_var.entry_points[ii].entry_is_header_seal = state.params.header_seal;
			const_var.entry_points[ii].entry_certified = const_var.entry_points[ii].entry_is_certified = state.params.certified_door;
			const_var.entry_points[ii].entry_chain_hoist = const_var.entry_points[ii].entry_is_chain_hoist = state.params.chain_hoist;
			const_var.entry_points[ii].entry_note = params.extra_notes;
			const_var.entry_points[ii].entry_automatic_openers = const_var.entry_points[ii].entry_is_automatic_openers = state.params.automatic_openers;
			const_var.entry_points[ii].installation_is_end_wall = door.DoorObj.installation_is_end_wall;
			const_var.entry_points[ii].installation_is_side_wall = door.DoorObj.installation_is_side_wall;
			const_var.entry_points[ii].entry_insulated = door.DoorObj.insulated;
			if (params.m_s_n == 9 && const_var.entry_points[ii].parent_array_key == "Walk") {
				const_var.entry_points[ii].threshold = door.DoorObj.threshold;
			}

			if (action.value == "motorOption") {
				state.params.motor = !state.params.motor;
				door.DoorObj.motor = state.params.motor;
				const_var.entry_points[ii].entry_motor = door.DoorObj.motor;

				returnData = state.params.motor;
			}

			if (action.value == "motor") {
				const_var.entry_points[ii].entry_motor_price = action.event?.price;
				const_var.entry_points[ii].entry_motor_name = action.event?.name;
				returnData = action.event?.name;
			}

			if (action.value.includes("add_on_options")) {
				const_var.entry_points[ii]["entry_" + action.value] = action.bool_var == undefined || action.bool_var == false ? true : false;
				const_var.entry_points[ii]["entry_" + action.value + "_price"] = action.event;

				state.params[action.value] = !state.params[action.value];
				door.DoorObj[action.value] = state.params[action.value];
				returnData = state.params[action.value] + action.value;
			}
			if (action.value == "insulated") {
				const_var.entry_points[ii].entry_price = parseFloat(action.componentObj.cost);
				if (const_var.entry_wall_location[const_var.entry_points[ii].component_wall_name].includes("side") == true) {
					const_var.entry_points[ii].entry_price =
						action.componentObj.side_cost != undefined && action.componentObj.side_cost != 0
							? parseFloat(const_var.entry_points[ii].entry_price) + parseFloat(action.componentObj.side_cost)
							: parseFloat(const_var.entry_points[ii].entry_price);
				}
				if (state.params.insulated == true) {
					const_var.entry_points[ii].entry_price = (parseFloat(const_var.entry_points[ii].entry_price) + parseFloat(action.event)).toFixed(2);
				}
			}

			if (action.value == "certified_door") {
				const_var.entry_points[ii].entry_price =
					parseFloat(action.componentObj.cost) +
					parseFloat(
						const_var.entry_wall_location &&
							const_var.entry_wall_location[const_var.entry_points[ii].component_wall_name] &&
							const_var.entry_wall_location[const_var.entry_points[ii].component_wall_name].includes("side") == true
							? parseFloat(action.componentObj.side_cost)
							: 0
					);
				if (state.params.certified_door == true && action.bool_var == true) {
					const_var.entry_points[ii].entry_price =
						action.componentObj.certified_cost != undefined
							? (parseFloat(const_var.entry_points[ii].entry_price) + parseFloat(action.componentObj.certified_cost)).toFixed(2)
							: const_var.entry_points[ii].entry_price + 0;
				}
			}

			if (const_var.entry_points[ii].entry_type == "garage_door" && action.value == "door_color_price") {
				let UpdateColorDoor = const_var.newDoorsArray.filter((data) => data.uniqueId == action.UniqueId);
				UpdateColorDoor[0].doorColor = params.g_d_c.replace("0x", "#");
				const_var.entry_points[ii].entry_garageDoor_color_Obj = action.event;
				const_var.entry_points[ii].garage_door_color = params.g_d_c;
				const_var.entry_points[ii].entry_garageDoor_color_price =
					const_var.garageDoorColor[state.params.g_d_c_id].percentage_of_cost > 0
						? (const_var.entry_points[ii].entry_price * const_var.garageDoorColor[state.params.g_d_c_id].cost) / 100
						: const_var.garageDoorColor[state.params.g_d_c_id].cost;
			}
			if (const_var.entry_points[ii].parent_array_key == "Garage" && const_var.garageDoorColor[state.params.g_d_c_id].percentage_of_cost > 0) {
				const_var.entry_points[ii].entry_garageDoor_color_price = (const_var.entry_points[ii].entry_price * const_var.garageDoorColor[state.params.g_d_c_id].cost) / 100;
			}
		}
		if (const_var.entry_points[ii].uniqueId != action.UniqueId) {
			if (const_var.entry_points[ii].entry_type == "garage_door") {
				const_var.garageDoorColor.map((value, key) => {
					if (value.name == "White" && const_var.entry_points[ii].garage_door_color.replace("0x", "#") == value.hex_value) {
						const_var.entry_points[ii].entry_garageDoor_color_Obj = value;
					}
				});
			}
		}
	}

	if (door && action.value != "extra_notes") {
		cuBuilding.cP("", undefined, holdIndex);
	}

	returnData =
		returnData +
		state.params.header_seal +
		action.UniqueId +
		state.params.chain_hoist +
		state.params.certified_door +
		state.params.extra_notes +
		state.params.automatic_openers +
		state.params.g_d_c +
		state.params.g_d_c_name +
		door.DoorObj.installation_is_end_wall +
		door.DoorObj.installation_is_side_wall +
		state.params.insulated;

	return {
		...state,
		newColor: returnData,
		action
	};
};
export const updateDoorWindowPosition = (state, action) => {
	const tempArray = [...const_var.newDoorsArray];
	const doorIndex = tempArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
	if (doorIndex !== -1) {
		if (action.positionX !== undefined) {
			tempArray[doorIndex].positionX = action.positionX;
			tempArray[doorIndex].position.positionX = action.positionX;
		}
		if (action.positionY !== undefined) {
			tempArray[doorIndex].positionY = action.positionY;
			tempArray[doorIndex].position.positionY = action.positionY;
		}
		state.const_var.newDoorsArray = tempArray;
	}

	const tempArray1 = [...const_var.entry_points];
	const doorIndex1 = tempArray1.findIndex((item) => item.uniqueId === action.doorUniqueId);
	if (doorIndex1 !== -1) {
		if (action.positionX !== undefined) {
			tempArray1[doorIndex1].entry_position.positionX = action.positionX;
		}
		if (action.positionY !== undefined) {
			tempArray1[doorIndex1].entry_position.positionY = action.positionY;
		}
		state.const_var.entry_points = tempArray1;
	}

	return {
		...state,
		newColor: JSON.stringify(state.const_var.newDoorsArray),
		action
	};
};
export const updateDoorWindowIcons = (state, action, activeWallP, newState) => {
	let doorWindowIconsPos = [];
	const vObjs = [];

	const intersectedDoor = cuComponent.getIntersectedObjects(action.event, vObjs);
	let leantoWalls = [
		"L_L_L_W",
		"L_L_F_W",
		"L_L_B_W",
		"L_L_F_S_W",
		"L_L_L_S_W",
		"L_L_R_S_W",
		"R_L_F_W",
		"R_L_B_W",
		"R_L_R_W",
		"R_L_F_S_W",
		"R_L_L_S_W",
		"R_L_R_S_W",
		"F_L_F_W",
		"F_L_R_W",
		"F_L_L_W",
		"F_L_F_S_W",
		"F_L_L_S_W",
		"F_L_R_S_W",
		"F_L_B_S_W",
		"B_L_F_W",
		"B_L_B_W",
		"B_L_S_W",
		"B_L_L_S_W",
		"B_L_R_S_W",
		"B_L_F_S_W",
		"B_L_B_S_W"
	];

	if (intersectedDoor.length > 0) {
		if (leantoWalls.includes(intersectedDoor[0].object.parent.userData.wallName) == true && params.isShowCenter == true) {
			doorWindowIconsPos = [];
		} else if (
			intersectedDoor.length > 0 &&
			intersectedDoor[0].object.parent.DoorObj &&
			intersectedDoor[0].object.name !== "hline" &&
			intersectedDoor[0].object.name !== "vline" &&
			((intersectedDoor[0].face.normal.x && intersectedDoor[0].face.normal.x < 0) ||
				(intersectedDoor[0].face.normal.y && intersectedDoor[0].face.normal.y < 0) ||
				(intersectedDoor[0].face.normal.z && intersectedDoor[0].face.normal.z < 0))
		) {
			let doorObj = intersectedDoor[0].object.parent;
			let doorWallName = doorObj && doorObj.userData.wallName;
			let doorcurrentUniqueId = doorObj && doorObj.userData.uniqueId;
			doorWindowIconsPos = cuComponent.updateDoorIconsPos(state, doorWallName, doorcurrentUniqueId);
		}
	}

	let cupolaEditIconsPos = [];
	const intersectedCupola = cuComponent.getIntersectedObjects(action.event, const_var.cupolaForMove);
	if (intersectedCupola.length > 0) {
		let cupolaObj = intersectedCupola[0].object.parent;
		let cupolaName = cupolaObj && cupolaObj.name;
		let currentCupolaUniqueId = cupolaObj && cupolaObj.userData.uniqueId;
	}

	if (state.doorWindowIconsPos.length === 0 && doorWindowIconsPos.length === 0 && state.cupolaEditIconsPos.length === 0 && cupolaEditIconsPos.length === 0 && activeWallP === state.params.activeWall) return newState;

	activeWallP = state.params.activeWall;

	return {
		...state,
		doorWindowIconsPos,
		cupolaEditIconsPos
	};
};
export const changeDoorWindowSize = (state, action) => {
	const validationValue = editValidation({
		compType: action.compType,
		compName: action.compName,
		width: action.width,
		height: action.height,
		wallname: action.wallName,
		parentkey: action.parentkey,
		childkey: action.childkey,
		nestedkey: action.nestedkey,
		positionX: action.positionX,
		positionY: action.positionY,
		sideArray: action.sideArray
	});
	if (validationValue.isEdit) {
		const tempArray = [...const_var.newDoorsArray];
		const doorIndex = tempArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
		if (doorIndex !== -1) {
			tempArray[doorIndex].width = action.width;
			tempArray[doorIndex].height = action.height;
			tempArray[doorIndex].positionX = action.positionX;
			tempArray[doorIndex].positionY = action.positionY;
			tempArray[doorIndex].minLimitX = validationValue.minLimitX;
			tempArray[doorIndex].actual_val = action.width + "x" + action.height;
		} else {
			state.const_var.showComponentEditBox = false;
			let alertText = "";
			if (action.compType === "garage_door" || action.compType === "garage_door_frameout") {
				alertText = "NoMoreGarageDoorsCanBeAdded";
			} else if (action.compType === "walkin" || action.compType === "walkin_frameout") {
				alertText = "NoMoreWalkInDoorsCanBeAdded";
			} else if (action.compType === "window" || action.compType === "window_frameout") {
				alertText = "NoMoreWindowsCanBeAdded";
			}
			state.const_var.isShowAlert = !state.const_var.isShowAlert;
			state.const_var.alertUsedFor = alertText;
		}
	}
	return {
		...state,
		action
	};
};

export const UpdateDoorWindowPosition = (state, action) => {
	const tempArray = [...const_var.newDoorsArray];
	const objIndex = tempArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
	if (objIndex !== -1) {
		tempArray[objIndex].minLimitX = action.minLimitX;
		tempArray[objIndex].maxLimitX = action.maxLimitX;
		state.const_var.newDoorsArray = tempArray;
	}
	return {
		...state,
		action
	};
};
export const handleClearComponent = (state, action) => {
	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	state.const_var.isShowAlert = true;
	state.const_var.alertUsedFor = "clearComponent";
	return {
		...state,
		action
	};
};
